import styled from 'styled-components';
import { media } from '../../../../styles-helper';

const AdRow = styled.div`
  height: 60px;
  border-bottom: 1px solid #d5d5d5;

  ${media.phone`
    height: 50px;
  `}
`;

export {
  AdRow,
};



// WEBPACK FOOTER //
// ./src/components/AdList/components/Ad/styles.js